import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

import {
	Banner,
	Button,
	fontSize,
	FontSizes,
	fontWeight,
	FontWeights,
	maxWidth,
	minWidth,
	Text,
	units,
} from '@calm-web/design-system';

import CalmLogoSvg from 'icons/calm-app-logo.svg';

export const Wrapper = styled.div`
	position: relative;
	background: ${palette('gradientCalmBusinessSelfServe')};
	height: 100vh;
	width: 100%;
	overflow-y: auto;
`;

export const FixedTopBar = styled.div`
	position: sticky;
	top: 0;
	display: flex;
	align-items: center;
	width: 100%;
	height: 64px;
	background-color: ${palette('white')};
	z-index: 1;
`;

export const CalmLogo = styled(CalmLogoSvg)`
	position: absolute;
	left: ${units(3)};

	width: ${units(6)};
	height: auto;

	${minWidth('desktop')} {
		left: ${units(5)};
	}
`;

export const Container = styled.div<{
	isCoveredLivesPage?: boolean;
	isPaymentPage: boolean;
}>`
	max-width: ${props => (props.isPaymentPage ? '592px' : '474px')};
	margin: auto;

	${maxWidth('mobileLarge')} {
		width: auto;
		margin: auto;
	}

	${props => props.isCoveredLivesPage && `width: 100%;`}
`;

export const Body = styled.div<{ $isLoader?: boolean }>`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: ${props => (props.$isLoader ? units(20) : 0)};
`;

const FlexColumnCenter = css`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
`;

export const StyledButton = styled(Button)`
	width: 100%;
`;
export const StyledButtonLink = styled(Button)``;
export const SignUpForm = styled.form`
	width: 100%;
	${FlexColumnCenter};

	div.StripeElement {
		padding: ${units(2, 0)};
	}
	input#ccName {
		padding-top: ${units(3)};
		padding-bottom: ${units(1)};
	}
`;

export const StyledText = styled(Text).attrs({
	size: FontSizes.sm,
	textColor: 'text',
})<{ $isPrivacyAndTermsPolicy?: boolean }>`
	text-align: center;
	line-height: ${units(3)};
	margin-top: ${units(2)};
	margin-bottom: ${props => (props.$isPrivacyAndTermsPolicy ? units(5) : units(0))};
`;

export const StyledLink = styled.a`
	${fontSize(FontSizes.sm)};
	color: ${palette('blue3')};
	text-decoration-line: none;
`;

export const Content = styled.div`
	${FlexColumnCenter};
	max-width: 600px;
	width: 100%;
	margin: ${units(0, 2)};

	${StyledButton} {
		min-width: ${units(22)};
	}
	${StyledButtonLink} {
		margin: ${units(2)};
	}
`;

export const ErrorBanner = styled(Banner).attrs({
	backgroundColor: 'error',
	textColor: 'white',
})`
	${fontWeight(FontWeights.Medium)};
	padding: ${units(1.25)} ${units(2.5)};
	letter-spacing: 0.17px;
	line-height: ${units(2.5)};
	box-shadow: none;
	margin-bottom: ${units(3)};
	width: 100%;
`;
